/* eslint-disable react/no-array-index-key */
import * as React from 'react'
import * as S from './styles'
import { HowItWorksColumn } from '@shared/interfaces/HowItWorks'
import HowItWorksItem from '@site/components/molecules/HowItWorksItem'
import { tagTheme } from '@taglivros/tag-components'
import { Page } from '@shared/interfaces/Pages'


const HowItWorksList = ( { data, colorTitle, page }: HowItWorksList.Props ): React.ReactElement => {
  return (
    <S.UnorderedList className="how-it-works-list">
      {data &&
        data.map( ( item, index ) => {
          const strapiImageUrl = Array.isArray( item.image ) ? item.image[ 0 ]?.url : ''
          return (
            <HowItWorksItem
              imageAlt={ item.imageAlt }
              imagePath={ page === 'home' ? strapiImageUrl : item.image }
              key={ String( index ) }
              secondaryText={ item.subtitle }
              title={ item.title }
              colorTitle={ colorTitle }
              page={ page }
            />
          )
        } ) }
    </S.UnorderedList>
  )
}

namespace HowItWorksList {
  export interface Props {
    data: HowItWorksColumn[]
    colorTitle: keyof typeof tagTheme.cores
    page: Page
  }
}

export default HowItWorksList
